import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { API_BASE_URL } from '../../config';
import './LandingHeader.css';

const LandingHeader = ({ activePage = 'home' }) => {
    const { t, i18n } = useTranslation(['navigation', 'common']);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [availableLanguages, setAvailableLanguages] = useState([]);
    const [currentLanguage, setCurrentLanguage] = useState(i18n.language || 'en');
    const isLoggedIn = !!localStorage.getItem('userId');

    useEffect(() => {
        fetch(`${API_BASE_URL}get_languages.php`)
            .then(res => res.json())
            .then(data => {
                if (data.status === 'success') {
                    setAvailableLanguages(data.languages);
                }
            })
            .catch(err => console.error("Failed to fetch languages", err));
    }, []);

    const handleLanguageChange = (e) => {
        const newLang = e.target.value;
        setCurrentLanguage(newLang);
        i18n.changeLanguage(newLang);
        localStorage.setItem('i18nextLng', newLang);
    };

    const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

    return (
        <header className="landing-header">
            <div className="container">
                <nav>
                    <div className="logo"><Link to="/">SkillTherapy AI</Link></div>
                    <ul className="nav-links">
                        <li><Link to="/" className={activePage === 'home' ? 'active' : ''}>{t('navigation:sidebar.home', 'Home')}</Link></li>
                        <li><Link to="/features" className={activePage === 'features' ? 'active' : ''}>{t('navigation:sidebar.features', 'Features')}</Link></li>
                        <li><Link to="/pricing" className={activePage === 'pricing' ? 'active' : ''}>{t('navigation:sidebar.pricing', 'Pricing')}</Link></li>
                        <li><Link to="/demo" className={activePage === 'demo' ? 'active' : ''}>{t('navigation:sidebar.demo', 'Demo')}</Link></li>
                        <li><Link to="/exam-booster">{t('navigation:sidebar.examBooster', 'Exam Booster')}</Link></li>
                        {!isLoggedIn && <li><Link to="/login">{t('common:login', 'Login')}</Link></li>}
                    </ul>
                    <div className="nav-actions">
                        {!isLoggedIn ? (
                            <Link to="/register" className="btn btn-primary join-btn">{t('common:signUp', 'Join Now')}</Link>
                        ) : (
                            <Link to="/dashboard" className="btn btn-primary join-btn">{t('navigation:sidebar.dashboard', 'Dashboard')}</Link>
                        )}
                        {availableLanguages.length > 0 && (
                            <select
                                value={currentLanguage}
                                onChange={handleLanguageChange}
                                className="lang-dropdown"
                            >
                                {availableLanguages.map(lang => (
                                    <option key={lang.id} value={lang.code}>
                                        {'🌐 '}{lang.name}
                                    </option>
                                ))}
                            </select>
                        )}
                        <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
                            {isMobileMenuOpen ? '✕' : '☰'}
                        </button>
                    </div>
                </nav>
            </div>

            {/* Mobile Menu */}
            <div className={`mobile-nav-overlay ${isMobileMenuOpen ? 'active' : ''}`}>
                <ul className="mobile-nav-links">
                    <li><Link to="/" onClick={toggleMobileMenu}>{t('navigation:sidebar.home', 'Home')}</Link></li>
                    <li><Link to="/features" onClick={toggleMobileMenu}>{t('navigation:sidebar.features', 'Features')}</Link></li>
                    <li><Link to="/pricing" onClick={toggleMobileMenu}>{t('navigation:sidebar.pricing', 'Pricing')}</Link></li>
                    <li><Link to="/demo" onClick={toggleMobileMenu}>{t('navigation:sidebar.demo', 'Demo')}</Link></li>
                    {!isLoggedIn && <li><Link to="/login" onClick={toggleMobileMenu}>{t('common:login', 'Login')}</Link></li>}
                    {availableLanguages.map(lang => (
                        <li key={lang.id} onClick={() => { i18n.changeLanguage(lang.code); toggleMobileMenu(); }}>
                            {lang.name}
                        </li>
                    ))}
                    {!isLoggedIn ? (
                        <li><Link to="/register" className="btn btn-primary" onClick={toggleMobileMenu}>{t('common:signUp', 'Sign Up')}</Link></li>
                    ) : (
                        <li><Link to="/dashboard" className="btn btn-primary" onClick={toggleMobileMenu}>{t('navigation:sidebar.dashboard', 'Dashboard')}</Link></li>
                    )}
                </ul>
            </div>
        </header>
    );
};

export default LandingHeader;
